import { takeEvery, put, call } from 'redux-saga/effects';
import { ACTION_TYPES } from 'src/constants';
import {
  productDetail,
  productOffersDetail,
  productOffersDelete,
  productList,
  createProductOffer,
} from 'src/redux/api';
import {
  productDetailSuccess,
  productDetailFailure,
  productOffersSuccess,
  productOffersFailure,
  productOffersDeleteSuccess,
  productOffersDeleteFailure,
  productListSuccess,
  productListFailure,
  createProductOffersSuccess,
  createProductOffersFailure,
} from 'src/redux/actions';

export function* watchProductRequests() {
  yield takeEvery(ACTION_TYPES.REQUEST_PRODUCT_DETAIL, requestProductDetail);
  yield takeEvery(ACTION_TYPES.REQUEST_PRODUCT_OFFERS, requestProductOffers);
  yield takeEvery(ACTION_TYPES.REQUEST_PRODUCT_OFFERS_DELETE, requestProductOffersDelete);
  yield takeEvery(ACTION_TYPES.REQUEST_PRODUCT_LIST, requestProductList);
  yield takeEvery(ACTION_TYPES.REQUEST_PRODUCT_OFFERS_CREATE, requestCreateProductOffers);
}

function* requestProductList(action) {
  try {
    const products = yield call(productList, action.payload);    
    yield put(productListSuccess(products || []));
  } catch (e) {
    yield put(productListFailure(e));
  }
}

function* requestProductDetail(action) {
  try {
    const product = yield call(productDetail, action.payload);
    yield put(productDetailSuccess(product));
  } catch (e) {
    yield put(productDetailFailure(e));
  }
}

function* requestProductOffers(action) {
  try {
    const offers = yield call(productOffersDetail, action.payload);
    yield put(productOffersSuccess(offers));
  } catch (e) {
    yield put(productOffersFailure(e));
  }
}

function* requestProductOffersDelete(action) {
  try {
    const offers = yield call(productOffersDelete, action.payload);
    yield put(productOffersDeleteSuccess(offers));
  } catch (e) {
    yield put(productOffersDeleteFailure(e));
  }
}

function* requestCreateProductOffers(action) {
  try {
    const offers = yield call(createProductOffer, action.payload);
    yield put(createProductOffersSuccess(offers));
  } catch (e) {
    yield put(createProductOffersFailure(e));
  }
}
